<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text">
          {{ $t("users.edituser") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <ValidationObserver
            ref="obs"
            v-slot="{ invalid, validated, handleSubmit }"
          >
            <v-form ref="form">
              <v-row>
                <v-col cols="6">
                  <ValidationProvider
                    name="$t('users.gender')"
                    rules="required"
                    v-slot="{ errors, valid }"
                  >
                    <v-select
                      required
                      cache-items
                      :items="$t('gender.items')"
                      item-text="label"
                      item-value="value"
                      v-bind:label="$t('users.gender')"
                      outlined
                      :error-messages="errors"
                      :success="valid"
                      v-model="dataext.gender"
                      :menu-props="{ offsetY: true }"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col>
                  <BaseValInput
                    rules="required|max:50"
                    v-model="dataext.first_name"
                    v-bind:label="$t('users.first_name')"
                  />
                </v-col>
              </v-row>
              <BaseValInput
                rules="required|max:150"
                v-model="dataext.last_name"
                v-bind:label="$t('users.last_name')"
              />

              <BaseValInput
                rules="required|max:150"
                v-model="dataext.name"
                v-bind:label="$t('users.name')"
              />
              <BaseValInput
                rules="required|max:100"
                v-model="dataext.function"
                v-bind:label="$t('users.function')"
              />
              <BaseValInput
                v-model="photo_a"
                label="Foto voor email"
              />
              <v-row>
                <v-col cols="6"
                  ><BaseValInput
                    rules="required|max:15"
                    v-model="dataext.telephone"
                    v-bind:label="$t('users.telephone')"
                /></v-col>
                <v-col
                  ><BaseValInput
                    rules="required|email"
                    v-model.trim="dataext.email"
                    label="email"
                    @keyup="lowercase"
                /></v-col>
              </v-row>
              <ValidationProvider
                name="$t('users.gender')"
                rules="required"
                v-slot="{ errors, valid }"
              >
                <v-select
                  required
                  cache-items
                  :items="teams"
                  item-text="team_name"
                  item-value="id"
                  label="Team"
                  outlined
                  v-model="dataext.team_id"
                  :menu-props="{ offsetY: true }"
                  :error-messages="errors"
                  :success="valid"
                ></v-select>
              </ValidationProvider>
              <v-divider></v-divider>
              <div class="primary--text mt-5 text-h6">
                {{ $t("users.auth") }}
              </div>
              <v-row>
                <v-col cols="6"
                  ><ValidationProvider
                    name="type"
                    rules="required"
                    v-slot="{ errors, valid }"
                    mode="eager"
                  >
                    <v-select
                      :items="roles"
                      label="Type"
                      outlined
                      v-model="dataext.type"
                      :menu-props="{ offsetY: true }"
                      :error-messages="errors"
                      class="mt-5"
                      :success="valid"
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="dataext.is_admin" label="ADMIN" />
                  <v-checkbox
                    v-model="dataext.is_superuser"
                    label="SUPERUSER"
                  />
                </v-col>
              </v-row>

              <v-divider></v-divider>
              <div class="primary--text mt-5 text-h6">
                {{ $t("users.perm") }}
              </div>
              <v-checkbox v-model="dataext.has_pcm" label="PCM" />
              <v-checkbox
                v-model="dataext.has_famchart"
                label="Familiestatuut"
              />
              <v-checkbox
                v-model="dataext.has_partchart"
                label="Parterstatuut"
              />
              <v-checkbox v-model="dataext.has_exitplan" label="Exitplanning" />

              <div class="text-end mr-15">
                <v-btn color="accent" @click="closeItem()" class="mr-8">{{
                  $t("crud.close")
                }}</v-btn>

                <v-btn
                  color="primary"
                  @click="handleSubmit(saveItem)"
                  :disabled="invalid"
                  >{{ $t("crud.change") }}</v-btn
                >
              </div>
            </v-form>
          </ValidationObserver>
          <FlashMessage :error="error" v-if="error" key="error" />
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import BaseValInput from "@/components/input/BaseValInput";
import { ValidationObserver } from "vee-validate";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import UserService from "@/services/UserService";
import { ValidationProvider } from "vee-validate";
export default {
  name: "Users",
  components: {
    FlashMessage,
    BaseValInput,
    ToolbarAuth,
    Navigation,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      dataext: {},
      roles: ["admin", "superuser", "user"],
      loading: null,
      error: null,
    };
  },
  methods: {
    lowercase() {
      this.dataext.email = this.dataext.email.toLowerCase();
    },
    getData() {
      let id = this.$route.params.id;
      this.loading = true;
      UserService.getUser(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    saveItem() {
      const payload = {
        team_id: this.dataext.team_id,
        first_name: this.dataext.first_name,
        last_name: this.last_name,
        name: this.dataext.name,
        gender: this.dataext.gender,
        telephone: this.dataext.telephone,
        photo_a: this.photo_a,
        email: this.dataext.email,
        function: this.dataext.function_b,
        is_admin: this.dataext.is_admin,
        is_superuser: this.dataext.is_superuser,
        has_pcm: this.dataext.has_pcm,
        has_famchart: this.dataext.has_famchart,
        has_partchart: this.dataext.has_partchart,
        has_exitplan: this.dataext.has_exitplan,
        type: this.dataext.type,
      };
      this.error = null;
      let UserId = this.$route.params.id;
      UserService.updateUser(UserId, payload)
        .then(() => {
          this.$router.replace({ name: "usersIndex" });
        })
        .catch((error) => (this.error = getError(error)));
    },

    closeItem() {
      this.$router.replace({ name: "usersIndex" });
    },
  },
  computed: {
    ...mapGetters("team", ["teams"]),
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped></style>
